export default __webpack_public_path__ + "static/media/juice-bottle-lockup-mobile@2x.3fda888a.png";